import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "@/hooks/useTranslation";
import { ListingDTO, ListingOwnerType, ListingType } from "@shaarp/common";
import CreateListingForm from "./create-listing-form";

export default function DialogCreateListing({
  defaultOwnerType,
  defaultListingType,
  defaultAssigneeId,
  searchQuery,
  companiesIds,
  employeesIds,
  onClose,
  onCreated,
}: {
  defaultOwnerType?: ListingOwnerType;
  defaultListingType?: ListingType;
  defaultAssigneeId?: string;
  searchQuery?: string;
  companiesIds?: readonly string[];
  employeesIds?: readonly string[];
  onClose: () => void;
  onCreated: (listing: ListingDTO) => void;
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-[800px] w-full">
        <DialogHeader>
          <DialogTitle>{t("listing.dialog.create.title")}</DialogTitle>
        </DialogHeader>
        <CreateListingForm
          variant="dialog"
          defaultOwnerType={defaultOwnerType}
          defaultListingType={defaultListingType}
          defaultAssigneeId={defaultAssigneeId}
          searchQuery={searchQuery}
          companiesIds={companiesIds}
          employeesIds={employeesIds}
          onCancel={onClose}
          onCreated={onCreated}
        />
      </DialogContent>
    </Dialog>
  );
}
